import { render, staticRenderFns } from "./AxiosSelect.vue?vue&type=template&id=52f2e3de&"
import script from "./AxiosSelect.vue?vue&type=script&lang=js&"
export * from "./AxiosSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports